import axios from 'axios';
import type { EndpointMap } from '@zenos/front-end-util-types';

const endpoints = {
  getToken: '/v1/auth',
  logout: '/v1/auth/logout',
  refresh: '/v1/auth/refresh',
} satisfies EndpointMap;

export type AuthSession = {
  expiry: number;
};

const authRequestConfig = {
  withCredentials: true,
} as const;

export async function fetchToken(
  code: string,
  redirectUri: string,
  state: string,
) {
  return (
    await axios.post<AuthSession>(
      endpoints.getToken,
      { code, redirectUri, state },
      authRequestConfig,
    )
  ).data;
}

export async function refreshSession() {
  return (
    await axios.post<AuthSession>(endpoints.refresh, {}, authRequestConfig)
  ).data;
}

export async function logOut() {
  return (await axios.post(endpoints.logout, {}, authRequestConfig)).data;
}
